import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import { addSuccessMessage } from 'actions';

export const SPORTSMEN_PATCH_REQUEST = 'PATCH_SPORTSMEN_REQUEST';
export const SPORTSMEN_PATCH_FAILURE = 'PATCH_SPORTSMEN_FAILURE';
export const SPORTSMEN_PATCH_SUCCESS = 'PATCH_SPORTSMEN_SUCCESS';

export const patchSportsman = (data, id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchSportsmanRequest());
        return axios(apiRequestOptions(apiPath.SPORTSMEN.PATCH, data, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(patchSportsmanSuccess(response.data));
                dispatch(addSuccessMessage('Sportsman successfully changed'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postSportsmanFailure(error));
                dispatch(errorRequestHandler(error));
            })
    }
}

const patchSportsmanRequest = () => ({type: SPORTSMEN_PATCH_REQUEST});
const postSportsmanFailure = error => ({type: SPORTSMEN_PATCH_FAILURE, error});
const patchSportsmanSuccess = sportsman => ({type: SPORTSMEN_PATCH_SUCCESS, sportsman})
